/**
 * Event Fade Calculator
 *
 * Determines whether an event is in the past and provides
 * opacity values for temporal fading of event cards.
 */

const PAST_OPACITY = 0.45;
const CURRENT_OPACITY = 1.0;

export class EventFadeCalculator {
  /**
   * Returns true if the event's start date/time is before the current moment.
   */
  static isEventPast(startDate: string, startTime?: string | null): boolean {
    const now = new Date();

    if (startTime) {
      const [hours, minutes] = startTime.split(':').map(Number);
      const eventDateTime = new Date(`${startDate}T00:00:00`);
      eventDateTime.setHours(hours, minutes, 0, 0);
      return eventDateTime < now;
    }

    // All-day event: consider past if the entire day has ended
    const endOfDay = new Date(`${startDate}T23:59:59`);
    return endOfDay < now;
  }

  /**
   * Returns the appropriate opacity for an event card based on temporal distance.
   */
  static opacityForEvent(startDate: string, startTime?: string | null): number {
    return EventFadeCalculator.isEventPast(startDate, startTime)
      ? PAST_OPACITY
      : CURRENT_OPACITY;
  }
}
